import { render } from "./Privacy.m.vue?vue&type=template&id=59d19958&scoped=true"
import script from "./Privacy.m.vue?vue&type=script&lang=js"
export * from "./Privacy.m.vue?vue&type=script&lang=js"

import "./Privacy.m.vue?vue&type=style&index=0&id=59d19958&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d19958"]])

export default __exports__